import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Amplify } from "aws-amplify";
import Router from "./Router.tsx";
import mixpanel from "mixpanel-browser";
import * as dayjs from "dayjs";
import "dayjs/locale/fr";
import LogRocket from "logrocket";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import locizeBackend from "i18next-locize-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// @ts-ignore
$crisp.push(["do", "chat:hide"]);
// @ts-ignore
$crisp.push([
  "on",
  "chat:closed",
  () => {
    // @ts-ignore
    $crisp.push(["do", "chat:hide"]);
  },
]);

const ENV_LOG_ROCKET = ["prod", "staging"];

if (ENV_LOG_ROCKET.includes(import.meta.env.VITE_ENVIRONMENT)) {
  LogRocket.init("mcqtbu/krunsh");
}

const buildDomain =
  import.meta.env.VITE_DOMAIN_NAME === "localhost:5173"
    ? `http://localhost:5173/`
    : `https://${import.meta.env.VITE_DOMAIN_NAME}/`;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_AUTH_URL,
          scopes: [
            "openid",
            "aws.cognito.signin.user.admin",
            "email",
            "phone",
            "profile",
          ],
          redirectSignIn: [buildDomain],
          redirectSignOut: [`${buildDomain}explorer/sign-in`],
          responseType: "code",
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_GRAPHQL_API_ENDPOINT,
      region: import.meta.env.VITE_GRAPHQL_API_REGION,
      defaultAuthMode: "userPool",
    },
  },
});

mixpanel.init("8b635caf6d61f66cbcc2c4275b5aff0c", {
  autocapture: true,
  record_sessions_percent: 100,
  api_host: "https://api-eu.mixpanel.com",
});

dayjs.locale("fr-FR");

i18n
  .use(locizeBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    react: {
      useSuspense: false,
    },
    backend: {
      projectId: "bceefe71-55a8-4454-ab48-11c5b58fa63f",
      cache: false,
    },
    saveMissing: false,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
